
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tjeneste/[slug]",
      function () {
        return require("private-next-pages/tjeneste/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tjeneste/[slug]"])
      });
    }
  